import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useLocation, useLink } from '@grandvisionhq/frk-routing';
import { Types } from '@grandvisionhq/graphql';
import { ToastProvider } from '@grandvisionhq/iris-ui';
import '../../../../services/tealium/dist/es/types/shared/products.js';
import '../../../../services/tealium/dist/es/events/event-properties-provider.js';
import { useDispatchTrackClickEvent } from '../../../../services/tealium/dist/es/events/use-track-click-event.js';
import '../../../../services/tealium/dist/es/events/use-track-error-event.js';
import { appendQueryParamToUrl } from '@grandvisionhq/utils';
import '../../../../context/PaymentsUI/context.js';
import '@paypal/react-paypal-js';
import '@grandvisionhq/state';
import { PaypalPaymentEventsProvider } from '../../../../context/Paypal/PaypalPaymentEventsContext.js';
import { useCreatePaypalPaymentEvents } from '../../../../hooks/paypal/use-create-paypal-payment-events.js';
import { useIsExpressPaypalSupportedForCart } from '../../../../hooks/use-is-express-paypal-supported.js';
import '../../../../models/adyen/payment-type.js';
import { ExpressPaymentMethod, PaymentMethod } from '../../../../models/cart-payment-methods/cart-payment-methods.js';
import '../../../../models/googlePay/types.js';
import '../../../../models/payment/types.js';
import '../../../../models/paypal/context.js';
import { PaypalActionButtonContainer } from './PaypalActionButtonContainer.js';

const PaypalExpressButton = ({ cartId , cartHash , isOrderInProgress =false , setIsOrderInProgress , onClickHandler  })=>{
    const [referenceId, setReferenceId] = React.useState(undefined);
    const [paymentToken, setPaymentToken] = React.useState(undefined);
    const dispatchTealiumTrackEvent = useDispatchTrackClickEvent();
    const { replace  } = useLocation();
    const expressCheckoutLink = useLink({
        route: 'express-overview',
        params: {
            type: ExpressPaymentMethod.PAYPAL,
            cartId,
            cartHash,
            referenceId: '',
            paymentToken: ''
        }
    });
    // Need to redirect through an effect because onPaymentAuthorization is called inside
    // PayPal modal with a different context than the one we are using here. This means that
    // we won't have access to the paymentToken from initiatePaypalTransaction when we need to redirect.
    React.useEffect(()=>{
        if (referenceId && paymentToken && (expressCheckoutLink === null || expressCheckoutLink === void 0 ? void 0 : expressCheckoutLink.href)) {
            setIsOrderInProgress === null || setIsOrderInProgress === void 0 ? void 0 : setIsOrderInProgress(true);
            replace(appendQueryParamToUrl(expressCheckoutLink.href, {
                referenceId,
                paymentToken
            }));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        replace,
        referenceId,
        paymentToken,
        expressCheckoutLink === null || expressCheckoutLink === void 0 ? void 0 : expressCheckoutLink.href
    ]);
    const handleOnClick = React.useCallback(()=>{
        dispatchTealiumTrackEvent({
            data_element_id: 'Summary_PayPalCheckout',
            data_description: 'checkout_with_paypal'
        });
        onClickHandler && onClickHandler(PaymentMethod.PAYPAL);
    }, [
        dispatchTealiumTrackEvent,
        onClickHandler
    ]);
    const paypalPaymentEvents = useCreatePaypalPaymentEvents({
        cartId,
        // Subscription is always disabled for express checkout
        hasSubscription: false,
        onPaymentAuthorization: setReferenceId,
        onPaymentTokenReceive: setPaymentToken,
        checkoutType: Types.CheckoutType.EXPRESS,
        onClick: handleOnClick
    });
    return /*#__PURE__*/ React.createElement(PaypalPaymentEventsProvider, swcHelpers.extends({
        orderType: "regular"
    }, paypalPaymentEvents), /*#__PURE__*/ React.createElement(PaypalActionButtonContainer, {
        isDisabled: isOrderInProgress
    }));
};
const PaypalExpressButtonContainer = (props)=>{
    const { cartId  } = props;
    const { isExpressPaypalSupported , loading , error  } = useIsExpressPaypalSupportedForCart(cartId);
    if (error || !isExpressPaypalSupported || loading) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(ToastProvider, {
        closeButtonDescription: "close paypal message",
        defaultTimeout: 6000
    }, /*#__PURE__*/ React.createElement(PaypalExpressButton, swcHelpers.extends({}, props)));
};

export { PaypalExpressButtonContainer };
//# sourceMappingURL=PaypalExpressButton.js.map
